import moment from 'moment';

export interface LocalStorageItemWithExpirationDate<T = any> {
    ttlMinutes?: number;
    lastUpdated?: Date;
    data: T;
}

export function setLocalStorageItemWithExpirationDate<T>(
    key: string,
    data: T
): void {
    if (!window.localStorage) {
        throw new Error('localStorage is not available');
    }

    const preparedData = {
        data,
        lastUpdated: moment().toDate(),
        ttlMinutes: moment.duration(15, 'minutes').asMinutes(),
    };

    window.localStorage.setItem(key, JSON.stringify(preparedData));
}

export function getLocalStorageItemWithExpirationDate<T = any>(
    key: string
): T | null {
    try {
        const item = window.localStorage.getItem(key);

        if (item) {
            const deserializedItem: LocalStorageItemWithExpirationDate<T> = JSON.parse(
                item
            );
            const expiryDate = moment(deserializedItem.lastUpdated)
                .add(deserializedItem.ttlMinutes, 'minutes')
                .toDate();
            if (moment().isAfter(expiryDate)) {
                // Remove if expired
                window.localStorage.removeItem(key);
                return null;
            } else {
                return deserializedItem.data;
            }
        } else {
            return null;
        }
    } catch (err) {
        console.log(err);
        return null;
    }
}
